module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAABFklEQVRIie3TvyuFYRTA8Q8xmSSLwiS/IslgUWaDhZS/wMho0jswGG0WymKRyWBWZJBSfsSG5S7KQFIGeusZbrf3vfe97nTr+U5PnfOc73nO6RGJRCJNR0tWw0mSHOAdaw0+6BCTSZIMVQZacy50YhW7DUiPsIz7rGCeeB7bWMFJncJ0ihdYxAYWspLaqhRYxwc2cY4Z/NaQduAKw2FNO3mJ1cQpWyhhD0+YwFdObg9u0I2lMOpc8kZdzn4Y2wBe0ZeRM4rnIJ2rJVVQnHKMWXThBYNlsWncoR1TOC1SsKg45Qzj4fyIkfSr4BLfoZnrosVq7biSW/TjoeyblEJDb/UUqlcs7Lk3NPGDMXz+o04kEok0E/gDprsuciI0DfoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/down-arrow.png
// module id = gToi
// module chunks = 1